// src/api/branches.js
// Branches — CHAIN only. See API docs §3.
import api from "../lib/apiClient";

export const listBranches = (params = {}) =>
  api.get("/branches", { params }).then((r) => r.data);

export const getBranch = (id) =>
  api.get(`/branches/${id}`).then((r) => r.data);

export const createBranch = (payload) =>
  api.post("/branches", payload).then((r) => r.data);

export const updateBranch = (id, payload) =>
  api.patch(`/branches/${id}`, payload).then((r) => r.data);

export const deleteBranch = (id) =>
  api.delete(`/branches/${id}`).then((r) => r.data);
